import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import React from "react";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

const FooterCommonLogin = () => {
  return (
    <>
      {/* Partner Logos */}
      <Box sx={{ bgcolor: "#fff", py: 4 }}>
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 8 } }}>
          <Stack
            direction="row"
            spacing={4}
            alignItems="center"
            gap={2}
            justifyContent="center"
            flexWrap="wrap"
          >
            <Box
              component="img"
              src={require("@assets/images/Digital-India.png")}
              alt="Digital India"
              sx={{ height: 40 }}
            />
            <Box
              component="img"
              src={require("@assets/images/Meri-Pehchaan.png")}
              alt="Meri Pehchaan"
              sx={{ height: 40 }}
            />
            <Box
              component="img"
              src={require("@assets/images/Bharat-Kosh.png")}
              alt="Bharatkosh"
              sx={{ height: 40 }}
            />
            <Box
              component="img"
              src={require("@assets/images/cdac.png")}
              alt="C-DAC"
              sx={{ height: 40 }}
            />
            <Box
              component="img"
              src={require("@assets/images/national-corruption.png")}
              alt="C-DAC"
              sx={{ height: 40 }}
            />
          </Stack>
        </Container>
      </Box>
      {/* footer */}

      <Box sx={{ bgcolor: "#3B1A77", color: "#fff", py: 1.5 }}>
        <Container>
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems="center"
            justifyContent="center" // center content
            spacing={{ xs: 1, md: 2 }}
          >
            <Typography
              variant="caption"
              sx={{
                fontSize: 14,
                textAlign: "center", // center text
                width: "100%", // full width for consistent centering
                opacity: 0.95
              }}
            >
              © 2026 - Copyright. All rights reserved. Developed by Digital
              India Corporation
            </Typography>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default FooterCommonLogin;
